import dayjs from 'dayjs';

import { convertIsoDateToString } from 'utils';

export const OVERVIEW_TABS = {
  CHECK_IN: 'checkIn',
  CHECK_OUT: 'checkOut',
  NEW_BOOKING: 'newBooking',
};

export const OVERVIEW_TAB_CONFIG = [
  {
    key: OVERVIEW_TABS.CHECK_IN,
    label: 'Khách đến',
    emptyText: 'Bạn không có khách đến trong hôm nay',
    timeLabel: 'Thời điểm khách đến:',
  },
  {
    key: OVERVIEW_TABS.CHECK_OUT,
    label: 'Khách đi',
    emptyText: 'Bạn không có khách đi trong hôm nay',
    timeLabel: 'Thời điểm khách đi:',
  },
  {
    key: OVERVIEW_TABS.NEW_BOOKING,
    label: 'Đặt phòng mới',
    emptyText: 'Bạn không có đặt phòng mới trong hôm nay',
    timeLabel: 'Thời điểm đặt phòng:',
  },
];

export const getOverviewBookingsByTab = (placeTodayBooking, tabKey) => {
  if (!placeTodayBooking) return [];

  switch (tabKey) {
    case OVERVIEW_TABS.CHECK_IN:
      return placeTodayBooking.todayCheckIn || [];
    case OVERVIEW_TABS.CHECK_OUT:
      return placeTodayBooking.todayCheckOut || [];
    case OVERVIEW_TABS.NEW_BOOKING:
      return placeTodayBooking.todayBooking || [];
    default:
      return [];
  }
};

export const getStayNights = (startedAt, endedAt) => {
  if (!startedAt || !endedAt) return 0;

  const nights = dayjs(endedAt).diff(dayjs(startedAt), 'day');
  return nights > 0 ? nights : 1;
};

export const getBookingTimeByTab = (booking, tabKey) => {
  const { checkInTime, checkOutTime } = booking;

  switch (tabKey) {
    case OVERVIEW_TABS.CHECK_IN:
      if (checkInTime && checkOutTime) return `${checkInTime} - ${checkOutTime}`;
      return checkInTime || checkOutTime || '-';
    case OVERVIEW_TABS.CHECK_OUT:
      return checkOutTime || '-';
    case OVERVIEW_TABS.NEW_BOOKING:
      return convertIsoDateToString(booking.createdAt) || '-';
    default:
      return '-';
  }
};
